export function ErrorCodeDocs() {
    const errors = [
      { code: '401', msg: 'Unauthorized', cause: 'Invalid or missing API Key.' },
      { code: '402', msg: 'Insufficient Credits', cause: 'Your monthly message limit has been reached.' },
      { code: '404', msg: 'Device Not Found', cause: 'The device_id provided does not exist.' },
      { code: '422', msg: 'Device Disconnected', cause: 'The WhatsApp device is not currently linked.' },
      { code: '500', msg: 'Server Error', cause: 'Internal system error, please try again later.' },
    ];
  
    return (
      <div>
        <h2 className="fw-bold">Error Codes</h2>
        <p className="text-muted">Standard HTTP status codes and specific API error responses.</p>
        
        <div className="table-responsive mt-4">
          <table className="table table-hover border rounded-3">
            <thead className="bg-light">
              <tr>
                <th className="px-3">Code</th>
                <th>Message</th>
                <th>Common Cause</th>
              </tr>
            </thead>
            <tbody>
              {errors.map(err => (
                <tr key={err.code}>
                  <td className="px-3"><span className="badge bg-danger-subtle text-danger">{err.code}</span></td>
                  <td className="fw-bold">{err.msg}</td>
                  <td className="text-muted small">{err.cause}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    );
  }